import { SetStateAction, useEffect, useRef, useState } from "react";


import MdPayment from "assets/mdPay.svg";

import ActiveUser from "../../assets/svg/settings/active/user.svg";
import ActiveBriefcase from "../../assets/svg/settings/active/briefcase.svg";
import ActivePeople from "../../assets/svg/settings/active/people.svg";
import CommodityServantActive from "../../assets/svg/iconSidebar/CommodityServantdark.svg";

import ActiveAccounting from "../../assets/svg/settings/active/accounting.svg";
import ActiveCalendar from "../../assets/svg/settings/active/calendar.svg";
import ActiveDocumentText from "../../assets/svg/settings/active/document-text.svg";
import ActiveRefreshCircle from "../../assets/svg/settings/active/refreshCircle.svg";
import ActiveCommand from "../../assets/svg/settings/active/command-square.svg";

import ActiveDocumentCode from "../../assets/svg/settings/active/document-code.svg";
import ActiveSmsEdit from "../../assets/svg/settings/active/smsEdit.svg";
import ActiveNotification from "../../assets/svg/settings/active/notification.svg";
import ActiveOfflineMode from "../../assets/svg/settings/active/offlineMode.svg";
import ActiveReceiptSearch from "../../assets/svg/settings/active/receipt-search.svg";
import ActivePrinter from "../../assets/svg/settings/active/printer.svg";
import ActiveTaxClient from "../../assets/svg/settings/active/taxClient.svg";

import SettingSideBar from "./SettingSideBar";
import ChortkeOffline from "components/Profile/profileInner/ChortkeOffline";
import API from "components/Profile/profileInner/API";
import SendSmsSetting from "./settingPages/SendSmsSetting";
import NotificationSettings from "./settingPages/NotificationSettings";
import AccountingSettings from "./settingPages/AccountingSettings";
import FiscalYear from "./settingPages/FiscalYear";
import FactorSettings from "./settingPages/FactorSettings";
import UpdateSetting from "./settingPages/UpdateSetting";
import PriceListSettings from "./settingPages/PriceListSettings";
import ProfileDetails from "components/Profile/profileInner/ProfileDetails";
// import { Formik, useFormikContext } from "formik";
// import { useDispatch, useSelector } from "react-redux";
// import { apiUpdateProfile } from "api/appApi";
import BusinessInfo from "components/Profile/profileInner/BusinessInfo";
// import Users from "pages/user/Users";
import Users from "components/User/Users";
import { apiGetAppSettings, apiSetAlert, apiSetAppSettings } from "api/appApi";
import ShortcutSettings from "./settingPages/ShortcutSettings";
import { appSetSettings } from "store/actions/appAction";
import PrintFactorSetting from "./settingPages/PrintFactorSettings";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "store/store";
import { errorDispatcher } from "helpers";
import TaxClientSettings from "./settingPages/taxClient/TaxClientSettings";
import PeopleSettings from "./settingPages/PeopleSettings";
import PosSetting from "components/Profile/profileInner/PosSetting";
import ProductsSetting from "./settingPages/ProductsSetting";

interface SubSection {
  label: string;
  icon: string;
  ActiveIcon: string;
  key: string;
  tag: string[];
  Component: any;
  selfClass?: boolean;
}

interface SettingData {
  label: string;
  subSection: SubSection[];
}

const SettingsDashboard = () => {
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [selectSetting, setSelectSetting] = useState<SubSection>(settingSideBarData[0].subSection[0]);
  const { Component }: any = selectSetting;
  const postRef: any = useRef(null);
  const [settingData, setSettingData] = useState<Partial<SettingData>>({});
  const dispatch = useAppDispatch();
  const { key } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const businessState = useAppSelector((state) => state).businessReducer;

  useEffect(() => {
    initialData();
    // apiGetAppSettings({ token: businessState?.business?.token });
  }, []);
  useEffect(() => {
    const currentSetting = settingSideBarData.flatMap((x) => {
      return x.subSection.find((y) => y.key === key) || [];
    });

    if (currentSetting.length > 0 && currentSetting[0]) {
      setSelectSetting(currentSetting[0]);
    }
  }, [key]);

  const initialData = async () => {
    try {
      await apiGetAppSettings({ token: businessState?.business?.token }).then((response) => {
        setSettingData(response?.data.settings);
        dispatch(appSetSettings(response?.data.settings));
      });
    } catch (error) {}
  };

  const submitData = async () => {
    try {
      setLoading(true);
      await apiSetAppSettings({ token: businessState?.business?.token, settings: settingData }).then(() => {
        dispatch(apiSetAlert("تنظیمات با موفقیت ثبت شد", "success"));
        initialData();
      });
    } catch (error) {
      errorDispatcher(error, dispatch);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex w-full flex-col items-center min-h-[calc(100vh_-_4rem)]">
      <div className="container flex flex-col flex-1 md:p-12">
        <div className="flex flex-col w-full p-0 py-4 md">
          <h1 className="font-medium text-2xl text-[#424242]">تنظیمات</h1>
          <span className="font-normal text-sm text-[#6F6F6F]">شخصی سازی ترجیحات</span>
        </div>
        {/* settings container  */}
        <div className="relative w-full">
          <div className="flex w-full flex-wrap md:flex-nowrap flex-row flex-1 bg-[#FEFEFE] rounded-lg mt-10 p-2 md:py-8 md:px-6 ">
            {/* settings sidebar */}
            <SettingSideBar
              searchValue={searchValue}
              selectSetting={selectSetting?.key}
              setSearchValue={(value) => setSearchValue(value)}
              setSelectSetting={(value) => {
                navigate(`/settings/${value.key}`);
                setSelectSetting(value);
                window.scrollTo(0, 0);
              }}
              settingSideBarData={settingSideBarData}
            />

            {/* separator */}
            <div className="w-px rounded-full mx-8 bg-[#DBE8FA]" />

            {/* setting section */}
            <div className="py-3 md:basis-10/12">
              {selectSetting.key !== "PriceList" && !selectSetting.selfClass && (
                <div className="flex flex-row items-center w-full h-10 mb-11 ">
                  {selectSetting.key !== "Management" && (
                    <span className="ml-1 text-[#5B5B5C] text-xl font-medium">تنظیمات </span>
                  )}
                  <span className="text-[#5B5B5C] text-xl font-medium ">{selectSetting.label}</span>
                </div>
              )}
              <div className={!selectSetting.selfClass ? "flex w-full h-full flex-col md:p-6 p-2" : ""}>
                {selectSetting && (
                  <Component
                    ref={postRef}
                    showTitle={false}
                    settingData={settingData}
                    setSettingData={(data: SetStateAction<{}>) => {
                      setSettingData(data);
                    }}
                  />
                )}
                {/* <ProfileDetails ref={postRef}/> */}
              </div>
            </div>
          </div>
          {selectSetting.key === "Management" ||
          selectSetting.key === "UpdateInformation" ||
          selectSetting.key === "Offline" ||
          selectSetting.key === "API" ||
          selectSetting.key === "PriceList" ||
          selectSetting.key === "Moaddian" ||
          selectSetting.key === "userManagement"||
          selectSetting.key === "posSetting" ? null : (
            <div
              style={{ boxShadow: "0px -4px 17px 2px rgba(26, 25, 25, 0.06)" }}
              className="sticky bottom-0 flex items-center justify-end w-full h-16 px-6 bg-white rounded-lg"
            >
              {/*<button*/}
              {/*  onClick={() => {*/}
              {/*  }}*/}
              {/*  className="rounded-md  text-[#7D96B8] py-2 px-4 bg-white border border-[#7D96B8]"*/}
              {/*>*/}
              {/*  لغو*/}
              {/*</button>*/}
              {/* <button
                onClick={() => {
                  if (selectSetting.key === "Profile" || selectSetting.key === "BusinessInfo") {
                    postRef?.current?.submit();
                  } else {
                    submitData();
                  }
                }}
                className="px-5 py-2 mr-4 text-white rounded-md"
              >
                ذخیره تغییرات
              </button> */}
              <button
                onClick={() => {
                  if (selectSetting.key === "Profile" || selectSetting.key === "Business") {
                    postRef?.current?.submit();
                  } else {
                    submitData();
                  }
                }}
                type="button"
                className="flex flex-row px-5 py-2 mr-4 text-white rounded-md bg-blue-1"
                disabled={loading}
              >
                {loading && (
                  <svg
                    className="w-5 h-5 ml-3 -mr-1 text-white animate-spin"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                )}
                ذخیره تغییرات
              </button>
            </div>
          )}
        </div>
        {/* settings container  */}
      </div>
    </div>
  );
};

export default SettingsDashboard;

const settingSideBarData: SettingData[] = [
  {
    label: "عمومی",
    subSection: [
      {
        label: "حساب کاربری",
        icon: ActiveUser,
        ActiveIcon: ActiveUser,
        key: "Profile",
        tag: [
          "Profile",
          "حساب کاربری",
          "نام",
          "خانوادگی",
          "شماره موبایل",
          "رمز عبور",
          "تغییر رمز عبور",
          "ویرایش شماره موبایل",
        ],
        Component: ProfileDetails,
      },
      {
        label: "کسب و کار",
        icon: ActiveBriefcase,
        ActiveIcon: ActiveBriefcase,
        key: "Business",
        tag: [
          "کسب و کار",
          "Business",
          "نوع",
          "زمینه فعالیت",
          "نام قانونی",
          "شماره ثبت",
          "شناسه ملی",
          "کد اقتصادی",
          "آدرس",
          "کد پستی",
          "وبسایت",
          "تلفن",
          "فکس",
        ],
        Component: BusinessInfo,
      },
      {
        label: "مدیریت کاربران",
        icon: ActivePeople,
        ActiveIcon: ActivePeople,
        key: "userManagement",
        tag: ["مدیریت کاربران", "userManagement", "کاربر", "حذف کاربر", "ویرایش کاربر"],
        selfClass: true,
        Component: Users,
      },
    ],
  },
  {
    label: "مالی",
    subSection: [
      {
        label: "حسابداری",
        icon: ActiveAccounting,
        ActiveIcon: ActiveAccounting,
        key: "Accounting",
        tag: [
          "حسابداری",
          "Accounting",
          "سیستم حسابداری انبار",
          "روش ارزیابی انبار",
          "سیستم چندارزی",
          "واحد پول اصلی",
          "ارزها",
          "مالیات بر ارزش افزوده",
        ],
        Component: AccountingSettings,
      },
      {
        label: "سال مالی",
        icon: ActiveCalendar,
        ActiveIcon: ActiveCalendar,
        key: "FiscalYear",
        tag: ["سال مالی", "Fiscal Year", "عنوان سال مالی"],
        Component: FiscalYear,
      },
      {
        label: "فاکتور",
        icon: ActiveDocumentText,
        ActiveIcon: ActiveDocumentText,
        key: "Factor",
        tag: [
          "فاکتور",
          "Factor",
          "اجازه ثبت فاکتور در صورت کمبود موجودی",
          "اجازه ثبت حواله انبار در صورت کمبود موجودی",
          "عدم نمایش کالاهایی با موجود صفر یا منفی در فاکتور فروش",
          "اجازه ثبت ردیف تکراری در فاکتور",
          "غیرفعال کردن مالیات در فاکتور",
          "فعال سازی ارسال فاکتور آنلاین",
        ],
        Component: FactorSettings,
      },
      {
        label: "چاپ",
        icon: ActivePrinter,
        ActiveIcon: ActivePrinter,
        key: "PrintSetting",
        tag: [
          "به روز رسانی اطلاعات",
          "Update Information",
          "به روز رسانی اسناد فاکتورها",
          "به روز رسانی موجودی کالا",
          "به روز رسانی رسید انبار تراز افتتاحیه",
          "به روز رسانی رسید و حواله های انبار",
          "صدور اتوماتیک رسید و حواله انبار",
        ],
        Component: PrintFactorSetting,
      },
      // {
      //   label: "حساب های پیش فرض",
      //   icon: CardEdit,
      //   ActiveIcon: ActiveCardEdit,
      //   key: "DefaultAccounts",
      //   tag: [
      //     "حساب های پیش فرض",
      //     "Default Accounts",
      //     "رسید دریافت فاکتور فروش",
      //     "رسید پرداخت فاکتور برگشت از فروش",
      //   ],
      //   Component: DefaultAccountSettings,
      // },
      {
        label: "به روزرسانی اطلاعات",
        icon: ActiveRefreshCircle,
        ActiveIcon: ActiveRefreshCircle,
        key: "UpdateInformation",
        tag: [
          "به روز رسانی اطلاعات",
          "Update Information",
          "به روز رسانی اسناد فاکتورها",
          "به روز رسانی موجودی کالا",
          "به روز رسانی رسید انبار تراز افتتاحیه",
          "به روز رسانی رسید و حواله های انبار",
          "صدور اتوماتیک رسید و حواله انبار",
        ],
        Component: UpdateSetting,
      },
      {
        label: "لیست قیمت ها",
        icon: ActiveReceiptSearch,
        ActiveIcon: ActiveReceiptSearch,
        key: "PriceList",
        tag: ["لیست قیمت ها", "price list", ""],
        Component: PriceListSettings,
      },
      {
        label: "اتصال به سامانه مودیان",
        icon: ActiveTaxClient,
        ActiveIcon: ActiveTaxClient,
        key: "Moaddian",
        tag: ["اتصال به سامانه مودیان", "taxClient", ""],
        Component: TaxClientSettings,
      },
      {
        label: "فایل های مورد نیاز دستگاه کارت خوان",
        icon: MdPayment,
        ActiveIcon: MdPayment,
        key: "posSetting",
        tag: ["اتصال به دستگاه کارت خوان", "به پرداخت بانک ملت", ""],
        Component: PosSetting,
      },
    ],
  },
  {
    label: "سیستم",
    subSection: [
      {
        label: "نسخه آفلاین",
        icon: ActiveOfflineMode,
        ActiveIcon: ActiveOfflineMode,
        key: "Offline",
        tag: ["نسخه آفلاین", "offline"],
        Component: ChortkeOffline,
      },
      {
        label: "رابط برنامه نویسی (API)",
        icon: ActiveDocumentCode,
        ActiveIcon: ActiveDocumentCode,
        key: "API",
        tag: ["رابط برنامه نویسی (API)"],
        Component: API,
      },
      {
        label: "پنل پیامک",
        icon: ActiveSmsEdit,
        ActiveIcon: ActiveSmsEdit,
        key: "SMSPanel",
        tag: [
          "پنل پیامک",
          "SMS Panel",
          "خوش آمدگویی کاربران سیستم",
          "دعوت مشتریان به پنل حسابداری",
          "ارسال پیش فاکتور به مشتری",
          "اعلام ثبت نهایی فاکتور به مشتری",
          "ارسال لینک پرداخت سفارش به مشتری",
          "ارسال لینک پرداخت",
        ],
        Component: SendSmsSetting,
      },
      {
        label: "اعلانات",
        icon: ActiveNotification,
        ActiveIcon: ActiveNotification,
        key: "Notifications",
        tag: ["Notifications", "اعلانات"],
        Component: NotificationSettings,
      },
      {
        label: "میانبر های کیبورد",
        icon: ActiveCommand,
        ActiveIcon: ActiveCommand,
        key: "ShortcutSettings",
        tag: ["Shortcut", "keyboard", "میانبر های کیبورد"],
        Component: ShortcutSettings,
      },
    ],
  },
  {
    label: "سایر",
    subSection:[
      {
        label: "اشخاص",
        icon: ActivePeople,
        ActiveIcon: ActivePeople,
        key: "People",
        tag: [
          "اشخاص",
        ],
        Component: PeopleSettings,
      },
      {
        label: "محصول",
        icon: CommodityServantActive,
        ActiveIcon: CommodityServantActive,
        key: "Product",
        tag: [
          "محصول",
        ],
        Component: ProductsSetting,
      },
    ]
  }
];
